// extracted by mini-css-extract-plugin
module.exports = {"blockWithTwoCard":"styles_blockWithTwoCard__3eebD","title":"styles_title__36CNs","tableRow":"styles_tableRow__3CuhT","accordionButton":"styles_accordionButton__3HOyC"};